
export default {
  name: 'items',
  components: {},
  props: ['respData'],
  data () {
    return {
      responseData:{},
      headers_LineItems:[
        {text:"Item Id", value:"itemId"},
        {text:"Product Id", value:"productId"},
        {text:"Stock Id", value:"stockId"},
        {text:"Serial Number", value:"serialNumber"},
        {text:"Name", value:"name"},
        {text:"Quantity", value:"quantity"},
        {text:"Has Fuel", value:"hasFuel"},
      ],
    }
  },
  computed: {

  },
  mounted () {
    this.responseData = this.respData;
  },
  methods: {

  }
}


